import React, { Component } from 'react'
import $ from 'jquery'
import { Icon, Progress, Accordion } from 'semantic-ui-react'

let logoStyle = {height: '35vh', marginTop: '10vh', display: 'none'}

class ConfirmationPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      confirmNumber: null,
      message: '',
      percent: 0,
      isGuest: false,
      usingDocParser: false,
      isError: false,
      aiDataOpen: false
    }

    this.getStatus = this.getStatus.bind(this)
    this.statusInterval = null
  }

  componentDidMount() {
    let isGuest = localStorage.getItem('isGuest') == 'TRUE'
    let confirmNumber = this.props.id
    let usingDocParser = ['D', 'A'].includes(confirmNumber[0])
    this.setState({isGuest, confirmNumber, usingDocParser})
    this.getStatus()
    setTimeout(() => $('.calendly-badge-widget').hide(), 0)//hide calendar widget
    if (usingDocParser) {
      this.statusInterval = window.setInterval(() => this.getStatus(), 20000)
    }
    window.scrollTo(0, 0)
  }

  componentWillUnmount() {
    if (this.statusInterval) clearInterval(this.statusInterval)
  }

  getStatus() {
    //call api for doc parser status
    $.get(process.env.REACT_APP_API_URL + '/api/doc_parser_status/' + this.props.id, (result) => {
      let message = result.message
      let percent = result.percent
      let isError = result.isError
      this.setState({
        message,
        percent,
        isError,
        grokArgs: result.grok_args || null
      })
      if (this.props.onPercent) this.props.onPercent(this.props.id, percent)
      if ((percent == 100 || percent == 99) && this.statusInterval) {
        clearInterval(this.statusInterval)
        this.statusInterval = null
        if (percent == 100) {
          setTimeout(() => $('#ai-progress-'+this.props.id).fadeOut(600), 3000)
        }
      }
    })
  }

  render() {
    let {isGuest, confirmNumber, usingDocParser, message, percent, isError, grokArgs} = this.state

    let orderType = ''
    if (confirmNumber != null) {
      switch(confirmNumber[0]) {
        case 'H':
          orderType = 'hold'
          break
        case 'S':
          orderType = 'sales order'
          break
        case 'P':
          orderType = 'sales order'
          usingDocParser = false
          break
        case 'D', 'A':
          orderType = 'sales order'
          usingDocParser = true
          break
        case 'W':
          orderType = 'worksheet'
          break
        case 'V':
          orderType = 'VPO'
          break
        default:
          // code block
      }
    }

    let splitVpos = false
    if (orderType == 'VPO') {
      splitVpos = confirmNumber.indexOf(',V') > -1
    }

    if (orderType != '') {
      return (
        <div>
          <center>
            <h3 style={{fontSize: '24px'}}>
              <div style={{textAlign: 'left', marginTop: '40px'}}>
                <div style={usingDocParser ? {maxWidth: '60vw', margin: 'auto'} : {display: 'none'}} id={"ai-progress-"+this.props.id}>
                  {confirmNumber[0] === 'A' ? 'AI Progress' : 'Doc Parser Progress'} for REF #: &nbsp; {confirmNumber.replace(/,V/g, ", V")}
                  <Progress percent={percent} indicating error={isError} style={{marginTop: '3px'}}>
                    {message}
                  </Progress>
                </div>

                {percent == 100 && grokArgs && grokArgs.split_refs &&
                  <div style={{marginTop: 16, textAlign: 'left', marginLeft: '10px', fontSize: '16px', paddingTop: '30px'}}>
                    Burlington order split into {grokArgs.split_refs.length} orders.
                  </div>
                }

                {(percent == 100 || confirmNumber[0] === 'P') &&
                  <div>
                    {(grokArgs && grokArgs.split_refs ? grokArgs.split_refs : [confirmNumber]).map(ref =>
                      <a
                        key={ref}
                        target="_blank"
                        href={`/#/sales-orders/${parseInt(ref.slice(1), 10)}/edit`}
                        className="ui primary button"
                        style={{
                          padding: '22px 16px',
                          fontSize: 22,
                          fontWeight: 700,
                          marginTop: '10px',
                          marginLeft: '10px'
                        }}
                      >
                        <Icon name="external"/> Open {ref}
                      </a>
                    )}
                  </div>
                }

                {grokArgs &&
                  <Accordion style={{marginTop: 16, textAlign: 'left', fontSize: '12px'}}>
                    <Accordion.Title
                      active={this.state.aiDataOpen}
                      onClick={() => this.setState({ aiDataOpen: !this.state.aiDataOpen })}
                    >
                      <Icon name="dropdown" />
                      AI data
                    </Accordion.Title>
                    <Accordion.Content active={this.state.aiDataOpen}>
                      <pre style={{fontSize: 10, whiteSpace: 'pre-wrap', lineHeight: '15px'}}>
                        {JSON.stringify(grokArgs, null, 2)}
                      </pre>
                    </Accordion.Content>
                  </Accordion>
                }
              </div>
            </h3>
          </center>
        </div>
      )
    } else {
      return <div></div>
    }
  }
}

export default ConfirmationPage
